import { ObjectInfo } from "./object-info";
import { ObjectLabel } from "./object-label";
import { Placement } from "./placement";
import { Target } from "./target";

export enum RelationType {
    Contained = "Contained",
    Placed = "Placed",
    DeletedContained = "DeletedContained"
}

export class Relation {
    public __classname__: string = 'Relation';

    public Parent: string | null = null;
    public Child: string | null = null;
    public Type: RelationType | null = null;
    public Placements: Placement[] | null = null;
    public ParentVersion: string | null = null;
    public ChildVersion: string | null = null;
    public Rating: number | null = null;
    public Targets: Target[] | null = null;
    public ParentInfo: ObjectInfo | null = null;
    public ChildInfo: ObjectInfo | null = null;
    public ObjectLabels: ObjectLabel[] | null = null;

    constructor(params: RelationNamedParameters) {
        this.Parent = params.Parent ?? null;
        this.Child = params.Child ?? null;
        this.Type = params.Type ?? null;
        this.Placements = params.Placements ?? null;
        this.ParentVersion = params.ParentVersion ?? null;
        this.ChildVersion = params.ChildVersion ?? null;
        this.Rating = params.Rating ?? null;
        this.Targets = params.Targets ?? null;
        this.ParentInfo = params.ParentInfo ?? null;
        this.ChildInfo = params.ChildInfo ?? null;
        this.ObjectLabels = params.ObjectLabels ?? null;
    }
}

export interface RelationNamedParameters {
    Parent: string
    Child: string
    Type: RelationType
    Placements?: Placement[]
    ParentVersion?: string
    ChildVersion?: string
    Rating?: number
    Targets?: Target[]
    ParentInfo?: ObjectInfo
    ChildInfo?: ObjectInfo
    ObjectLabels?: ObjectLabel[]
}